// extracted by mini-css-extract-plugin
export default {"container":"info-box_container__IY789","content":"info-box_content__Gq143","mobileContainer":"info-box_mobileContainer__RpKDn","mobileTitle":"info-box_mobileTitle__D4y9w"};